const ResponsiveImageLoader = require(`./responsive-image-loader`)
const PrintBehaviour = require(`./print-behaviour`)
const KenticoBehaviourOverrides = require(`./kentico-behaviour-overrides`)
const ContactFormKenticoLoading = require(`./contact-form-kentico-loading`)
const ViewportUnitsBuggyfill = require('vendor/viewport-units-buggyfill');
const OnScreenItemToggler = require('./on-screen-item-toggler');
const FastClick = require('fastclick');
// const attachFastClick = require('fastclick');
import {updateScrollAnimation  } from '../components/site-wide-banner.js';
export default class App {
  constructor(options)
  {
    this.options = $.extend({}, options)
    this.initialise();
  }


  initialise()
  {
    this.$body = $("body");
    this.initSearchResultsFix();
    this.initialiseRequestAnimationFrameScript();
    new KenticoBehaviourOverrides({disableKenticoFormSubmission:true});
    new ContactFormKenticoLoading();
    new PrintBehaviour();
    ViewportUnitsBuggyfill.init();
    FastClick.attach(document.body);
    this.initialiseJqueryFunctions();
    this.initialiseResponsiveImageLoader();
    this.initialiseOnScreenItemToggler();
    this.onWindowResized();
    this.initialiseListeners();
    this.initialiseSelectricForm();
    updateScrollAnimation();
  }

  // /giphy hack (see gitesh)
  initSearchResultsFix()
  {
    if (!$(".js-search-results-appendFrom").length)
    {
      return;
    }

    var results = $('.js-search-results-appendFrom').text();
    $('.js-search-results-appendTo').append(results)
  }

  initialiseRequestAnimationFrameScript()
  {
    // http://paulirish.com/2011/requestanimationframe-for-smart-animating/
    // http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
    
    // requestAnimationFrame polyfill by Erik Möller
    // fixes from Paul Irish and Tino Zijdel
    
      var lastTime = 0;
      var vendors = ['ms', 'moz', 'webkit', 'o'];
      for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
          window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
          window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame']
                                    || window[vendors[x]+'CancelRequestAnimationFrame'];
      }
  
      if (!window.requestAnimationFrame)
      {
          window.requestAnimationFrame = function(callback, element)
          {
              var currTime = new Date().getTime();
              var timeToCall = Math.max(0, 16 - (currTime - lastTime));
              var id = window.setTimeout(function() { callback(currTime + timeToCall); }, timeToCall);
              lastTime = currTime + timeToCall;
              return id;
          };
      }
  
      if (!window.cancelAnimationFrame)
      {
          window.cancelAnimationFrame = function(id)
          {
              clearTimeout(id);
          };
      }
  }

  initialiseListeners()
  {
    $(window).resize(() =>  this.onWindowResized());
  }

  initialiseResponsiveImageLoader()
  {
    var responsiveImageLoaderOptions = {imageBreakPointSizes:[660, 1024, 1280, 1440],lazyLoadAllImages:true};
    new ResponsiveImageLoader(responsiveImageLoaderOptions);
  }
  
  initialiseOnScreenItemToggler()
  {
    new OnScreenItemToggler();
  }


  initialiseJqueryFunctions()
  {
    //Case insensitive Jquery Contains method
    $.expr[":"].containsNoCase = function (el, i, m)
    { 
        var search = m[3]; 
        if(!search)
        {
          return false; 
        }
        return eval("/" + search + "/i").test($(el).text()); 
    }; 
  }

  onWindowResized()
  {

    var desktopBreakpointSize = $("#bp-desktop").width();
    this.$body.removeClass("desktop").removeClass("mobile");
    if($(window).outerWidth() >= desktopBreakpointSize)
    {
      this.$body.addClass("desktop");
    }
    else
    {
      this.$body.addClass("mobile");
    }
  }

  initialiseSelectricForm(){
    $('select').selectric();
    $('select.c-label-select__fields').selectric({disableOnMobile: false,
      nativeOnMobile: false});
    var pageRequestManager = Sys.WebForms.PageRequestManager.getInstance();
    pageRequestManager.add_pageLoaded( onPageLoaded );

      if (!pageRequestManager.get_isInAsyncPostBack()) {
          pageRequestManager.add_beginRequest(BeginRequest);
          pageRequestManager.add_endRequest(EndRequest);
      }

      function BeginRequest(sender, args) {
        console.log('start');
      }

      function EndRequest(sender, args) {
        console.log('end');
      }

      function onPageLoaded( sender, args ) {//Loads everytime a page loads
          $('select').selectric();
          $('select.c-label-select__fields').selectric({disableOnMobile: false,
            nativeOnMobile: false});
          
        var panels = args.get_panelsUpdated();
          if ( panels.length ) {//Only happens when it is a postback
              console.log("async panel update");
          }
      }
  }
}



/** WEBPACK FOOTER **
 ** ./system/app.js
 **/